<template>
  <div>
    <div class="next-back">
      <router-link to="/ausstattung">Zurück</router-link>
    </div>
    <div class="container-fluid">
      <h2>Angebot anfordern</h2>
      <h3>Zusammenfassung</h3>
      <p>
        Hier sehen Sie eine Zusammenfassung der von Ihnen gewählten Speisen und
        Getränken sowie der Ausstattung. Wenn alles in Ordnung ist, dann füllen
        Sie bitte noch das Kontaktformular aus und senden uns Ihre
        Angebotsanfrage.
      </p>
      <div class="row">
        <div class="col-md">
          <h3>Ausgewählte Speisen</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <ul>
            <li v-for="(item, i) in selectedItems" :key="i">
              <strong>{{ item.amount + "x " }}</strong>
              <span v-html="item.title"></span> (
              <a class="kdz-delete-item" @click="remove(item.key)">entfernen</a>
              )
            </li>
          </ul>
        </div>
      </div>
    </div>

    <form class="container-fluid mt-4" @submit.prevent.stop="sendForm">
      <div class="row">
        <div class="col-md">
          <h3>Ihre Daten:</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <h4>Informationen zur Veranstaltung:</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label for="dateInput">Lieferdatum:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="date"
            name="date"
            id="dateInput"
            v-model="deliveryDate"
            required
          />
        </div>
        <div class="col-md-4">
          <label for="dateInput">Lieferzeitpunkt:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="time"
            name="time"
            id="timeInput"
            v-model="deliveryTime"
            required
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-8">
          <label for="eventInput">Anlass:</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="text"
            name="event"
            v-model="event"
            id="eventInput"
          />
        </div>
        <div class="col-md-4">
          <label for="dateInput">Personenanzahl:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge kdz-number-input"
            type="number"
            name="persons"
            v-model="persons"
            id="personsInput"
            required
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md">
          <h4>Wo findet die Veranstaltung statt?</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label for="streetInput">Straße und Hausnummer:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="text"
            name="street"
            v-model="street"
            id="streetInput"
            required
          />
        </div>
        <div class="col-md-2">
          <label for="postcodeInput">PLZ:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="text"
            name="postcode"
            v-model="postcode"
            id="postcodeInput"
            required
          />
        </div>
        <div class="col-md-4">
          <label for="cityInput">Ort:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="text"
            name="city"
            v-model="city"
            id="cityInput"
            required
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md">
          <h4>Ihre Kontaktdaten:</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <label for="nameInput">Name:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="text"
            name="name"
            v-model="name"
            id="nameInput"
            required
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-6">
          <label for="emailInput">E-Mailadresse:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="email"
            name="email"
            v-model="email"
            id="emailInput"
            required
          />
        </div>
        <div class="col-md-6">
          <label for="phoneInput">Telefonnummer:*</label>
          <input
            class="w3-input w3-border w3-round w3-xlarge"
            type="tel"
            name="phone"
            v-model="phone"
            id="phoneInput"
            required
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md">
          <h4>Fragen oder Wünsche?</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <textarea
            name=""
            id=""
            cols="30"
            rows="4"
            class="w3-input w3-border w3-round w3-xlarge"
            v-model="questions"
          ></textarea>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-1">
          <input
            type="checkbox"
            name="datenschutz"
            id="datenschutz"
            class="w3-check"
            v-model="acceptance"
            required
          />
        </div>
        <div class="col-md-11">
          <label for="datenschutz">
            Ich bin damit einverstanden, dass meine Daten gespeichert und zur
            Bearbeitung meiner Anfrage und Kontaktaufnahme telefonisch oder per
            E-Mail genutzt werden. Eine Weitergabe an Dritte erfolgt nicht.
            Meine Einverständniserklärung kann ich jederzeit kostenfrei und ohne
            jeden Nachteil mit Wirkung für die Zukunft widerrufen. Ich habe die
            Datenschutzerklärung zur Kenntnis genommen.
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-md kdz-honey">
          <input type="hidden" id="honey" v-model="honey" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md">
          <button type="submit" class="w3-xlarge send-button">Angebot anfordern</button>
        </div>
      </div>
    </form>
    <div class="container-fluid mt-4">
      <div class="row">
        <div
          :class="[
            'col w3-panel',
            {
              'w3-red': isResponseAnError,
              'w3-pale-green': !isResponseAnError,
            },
          ]"
          v-if="answer"
        >
          <h3 v-if="isResponseAnError">Fehler!</h3>
          <h3 v-if="!isResponseAnError">Erfolg!</h3>
          <p>{{ answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Formular",
  data() {
    return {
      honey: "",
      deliveryDate: "",
      deliveryTime: "",
      event: "",
      persons: "",
      street: "",
      postcode: "",
      city: "",
      name: "",
      email: "",
      phone: "",
      questions: "",
      acceptance: false,
      answer: "",
      isResponseAnError: false,
    };
  },
  computed: {
    ...mapGetters(["getSelection", "getCateringItems"]),
    selectedItems() {
      let items = [];
      Object.keys(this.getSelection).forEach((el) => {
        let res = this.getCateringItems.find(
          (elem) => elem.slug === el.replaceAll("_", "-")
        );
        if (res !== undefined) {
          items.push({
            title: res.title,
            amount: Number.parseInt(+this.getSelection[el]),
            key: el,
          });
        }
      });
      return items;
    },
  },
  methods: {
    ...mapMutations(["remove"]),
    sendForm() {
      if (this.honey !== "") {
        return;
      }
      let xhr = new XMLHttpRequest();
      xhr.addEventListener("load", (event) => {
        if (event.target.status === 200) {
          this.answer = event.target.responseText;
          this.isResponseAnError = false;
        } else {
          console.error(event.target.responseText);
          this.isResponseAnError = true;
        }
      });
      xhr.open(
        "POST",
        "https://landhotel-ossig.shopware-dresden.de/wp-json/son_catering/v1/send-catering"
      );
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      let formData = {
        items: this.selectedItems,
        form: {
          deliveryDate: {
            value: new Date(this.deliveryDate).toLocaleDateString("de-DE"),
            label: "Lieferdatum",
          },
          deliveryTime: {
            value: new Date(this.deliveryTime).toLocaleTimeString("de-DE"),
            label: "Lieferzeit",
          },
          event: {
            value: this.event,
            label: "Anlass",
          },
          persons: {
            value: this.persons,
            label: "Personenanzahl",
          },
          street: {
            value: this.street,
            label: "Straße Veranstaltungsort",
          },
          name: {
            value: this.name,
            label: "Name",
          },
          email: {
            value: this.email,
            label: "E-Mail",
          },
          phone: {
            value: this.phone,
            label: "Telefonnummer",
          },
          questions: {
            value: this.questions,
            label: "Anmerkungen / Fragen",
          },
          acceptance: {
            value: this.acceptance,
            label: "Datenschutz akzeptiert",
          },
        },
      };

      xhr.send(JSON.stringify(formData));
      console.log("Gesendet");
    },
  },
};
</script>

<style lang="scss" scoped>
.kdz-number-input {
  max-width: none;
  padding: 6px 12px;
}

.send-button {
  background-color: #586c3f;
  color: #fff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  &:hover {
    background-color: #7f9b5b;
  }
}

.kdz-honey {
  display: none !important;
}

.kdz-delete-item {
  color: red;
  cursor: pointer;
  &:hover {
    color: darkred;
  }
}
</style>